import { FormControl, MenuItem, Select, useTheme } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import {
  selectLanguage,
  setLanguage,
} from "../../redux/features/language/languageSlice";
import styled from "styled-components";
// import { usePayPalScriptReducer } from "@paypal/react-paypal-js";

const LanguageDropdown = ({ dashboardColors = false }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const currentLanguage = useSelector(selectLanguage);
  // const [{ options }, paypalDispatch] = usePayPalScriptReducer();

  const primaryColor = dashboardColors
    ? "var(--main-color)"
    : theme.palette.primary.main;
  const secondaryColor = dashboardColors
    ? "transparent"
    : theme.palette.secondary.main;

  const handleLanguageChange = (event) => {
    const newLanguage = event?.target?.value;
    const localeLang = newLanguage === "EN" ? "en_US" : "it_IT";

    dispatch(setLanguage(newLanguage));

    // paypalDispatch({
    //   type: "resetOptions",
    //   value: {
    //     ...options,
    //     locale: localeLang,
    //   },
    // });
  };

  const CustomFormControl = styled(FormControl)`
    & .MuiInputBase-root {
      min-width: 90px;
      background-color: transparent;
      &.MuiSelect-select-MuiInputBase-input-MuiInput-input {
      }

      & .MuiSvgIcon-root {
        color: ${primaryColor};
      }
      & .MuiInput-input {
        font-size: 16px;
        padding-right: 0px;
        color: ${primaryColor};
      }
    }
    & .MuiInput-underline:before {
      border-bottom: 1px solid ${primaryColor};
    }

    & .MuiInput-underline:after {
      border-bottom: 2px solid ${primaryColor};
    }
  `;

  return (
    <div>
      <CustomFormControl
        hiddenLabel={true}
        variant="standard"
        sx={{
          ml: 2,
        }}
      >
        <Select
          labelId="language-select-label"
          id="language-select"
          value={currentLanguage}
          label={<FormattedMessage id="header.language"></FormattedMessage>}
          onChange={handleLanguageChange}
          MenuProps={{
            PaperProps: {
              sx: {
                width: "auto",
                backgroundColor: secondaryColor,
                "& .MuiMenuItem-root": {
                  fontSize: "16px",
                },

                "& .MuiMenuItem-root.Mui-selected": {
                  backgroundColor: primaryColor,
                },

                "& .MuiMenuItem-root.Mui-selected:hover": {
                  backgroundColor: primaryColor,
                },
              },
            },
          }}
        >
          <MenuItem value={"EN"}>English</MenuItem>
          <MenuItem value={"IT"}>Italiano</MenuItem>
        </Select>
      </CustomFormControl>
    </div>
  );
};

export default LanguageDropdown;
